import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20flowing%20gradient%20background%20with%20warm%20amber%20and%20soft%20teal%20tones%20smooth%20curved%20shapes%20overlapping%20organic%20forms%20modern%20minimalist%20digital%20art&width=1600&height=600&seq=cta-91n-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/40 to-black/50" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-white mb-4">
          立即加入 91n.com，开启精彩旅程
        </h2>
        <p className="text-white/75 text-sm mb-8 max-w-xl mx-auto leading-relaxed">
          注册即享多重福利，海量资源触手可及。安全稳定的平台，随时随地畅享极致体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            免费注册
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-secondary-500 text-background-50 font-medium rounded-md hover:bg-secondary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            会员权益
          </Link>
        </div>
      </div>
    </section>
  );
}